
import React from "react";
import moment from "moment-timezone";
import { Row, Col, Card, OverlayTrigger, Tooltip, Image, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faDownload, faRocket } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';


export default (props) => {
  const currentYear = moment().get("year");
  const showSettings = props.showSettings;

  const toggleSettings = (toggle) => {
    props.toggleSettings(toggle);
  }

  return (
    <div>
    <footer className="footer section py-4 text-white" style={{ backgroundColor: '#282828' }}>
      <Row className="justify-content-center">
        <Col xs={12} lg={6} className="mb-4 mb-lg-0 text-center">
          <p className="mb-0">
            Copyright © {`${currentYear} `}
          </p>
        </Col>
      </Row>
    </footer>
  </div>
  
  );
};